import { Button } from '@novaquantis/design-system';
import OnboardingInfoBox from '../../../components/onboarding/OnboardingInfoBox';
import OnboardingStepActions from '../../../components/onboarding/OnboardingStepActions';
import { ALPACA_LINKS } from '../../../onboarding/onboardingSteps';
import {
  stepTitleClass,
  stepLeadClass,
  stepBodyClass,
  stepFootnoteClass,
  stepLinkSecondaryClass,
} from './stepStyles';

type Props = {
  onContinue: () => void;
  continuing: boolean;
};

const AlpacaKycStep = ({ onContinue, continuing }: Props) => (
  <div>
    <h1 className={stepTitleClass}>Complete Alpaca identity verification</h1>
    <p className={stepLeadClass}>
      After signup, Alpaca will guide you through Know Your Customer (KYC) verification in
      their dashboard. This typically includes confirming your email, enabling multi-factor
      authentication, and submitting identity documents.
    </p>
    <OnboardingInfoBox variant="gold">
      Verification can take a few hours on Alpaca&apos;s side. You will receive an email
      when your account is approved and ready to trade live capital. You can continue setup
      with a paper account while waiting.
    </OnboardingInfoBox>
    <p className={stepBodyClass}>
      Follow Alpaca&apos;s in-app prompts from your{' '}
      <a
        className={stepLinkSecondaryClass}
        href={ALPACA_LINKS.dashboard}
        target="_blank"
        rel="noopener noreferrer"
      >
        Alpaca dashboard
      </a>
      .
    </p>
    <OnboardingStepActions>
      <a href={ALPACA_LINKS.dashboard} target="_blank" rel="noopener noreferrer">
        <Button variant="outline">Open Alpaca dashboard</Button>
      </a>
      <Button type="button" onClick={onContinue} disabled={continuing} variant="glow">
        {continuing ? 'Saving…' : "I've submitted KYC"}
      </Button>
    </OnboardingStepActions>
    <p className={stepFootnoteClass}>
      <a
        className={stepLinkSecondaryClass}
        href={ALPACA_LINKS.kycGuide}
        target="_blank"
        rel="noopener noreferrer"
      >
        Alpaca guide: Live account &amp; KYC (non-US example)
      </a>
    </p>
  </div>
);

export default AlpacaKycStep;
